
































import { StepConfirmEmail } from "@/types";
import { mapState } from "vuex";
import Field from "@/components/basic/fields/Field.vue";
import RecaptchaButton from "@/components/basic/buttons/RecaptchaSubmitButton.vue";
import Vue from "vue";
import CodeField from "../basic/fields/CodeField.vue";

export default Vue.extend({
  name: "confirmEmail",
  data() {
    return {
      isValid: false,
      formData: {
        phoneNumber: "",
        phoneNumberPrefix: "",
        confirmEmailCode2: "      ",
      } as StepConfirmEmail,
      TRANSLATION_KEY: "steps.ConfirmEmail",
    };
  },
  mounted() {
    this.formData.phoneNumber = this.phoneNumber;
    this.formData.phoneNumberPrefix = this.phoneNumberPrefix;
  },
  methods: {
    checkLength() {
      this.isValid = (this.formData.confirmEmailCode2.match(/\d/g) || []).length === 6;
    },
    navigateBack() {
      window.history.back();
    },
  },
  computed: {
    ...mapState({
      phoneNumberPrefix: (state: any): string => state.response.phoneNumberPrefix,
      phoneNumber: (state: any): string => state.response.phoneNumber,
      isHybrid: (state: any): string => state.response.isHybrid,
    }),
  },
  components: {
    Field,
    RecaptchaButton,
    CodeField,
  },
});
